import { createEffect, sample, createStore } from 'effector';
import { createGate } from 'effector-react';
import { signout } from '@features/common';
import { rentObjectsApi } from '@features/effector-form/controls/rent-objects/api';
import {
  RentObjectsPayload,
  RentObjectsResponse,
} from '@features/effector-form/controls/rent-objects/types';

export const SimpleListControlGate = createGate<{
  parent_guids?: string | string[] | null;
}>();

export const $data = createStore<
  {
    guid: string;
    title: string;
  }[]
>([]);
export const $pending = createStore<boolean>(false);

const fxGetSimpleList = createEffect<
  RentObjectsPayload,
  RentObjectsResponse,
  Error
>().use(rentObjectsApi.getRentObjects);

$data
  .on(fxGetSimpleList.done, (state, { result }) => {
    if (Array.isArray(result?.areaList)) {
      return result.areaList.map((item) => ({
        id: item?.guid,
        label: item?.title || '',
      }));
    }
    return [];
  })
  .reset(signout);

$pending.on(fxGetSimpleList.pending, (_, pending) => pending).reset(signout);

sample({
  clock: SimpleListControlGate.state,
  filter: ({ parent_guids }) =>
    Array.isArray(parent_guids) ? parent_guids.length > 0 : Boolean(parent_guids),
  fn: ({ parent_guids }) => {
    if (Array.isArray(parent_guids)) {
      return { parent_guids };
    }

    if (typeof parent_guids === 'string') {
      return { parent_guids: [parent_guids] };
    }

    return null;
  },
  target: fxGetSimpleList,
});
